import type { ReactElement, ReactNode } from 'react'

export type PanelVariant = 'surface' | 'highlight'

export interface PanelProps {
  readonly variant?: PanelVariant
  readonly className?: string
  readonly children: ReactNode
}

/**
 * A container, and nothing more.
 *
 * No landmark role and no heading of its own: the section around it already
 * carries both, and a second one would make the landmark tree ambiguous. If a
 * panel ever needs a name, the page gives it one via `aria-labelledby`.
 */
export function Panel({ variant = 'surface', className, children }: PanelProps): ReactElement {
  const classes = ['panel', `panel--${variant}`, className ?? ''].join(' ').trimEnd()

  return <div className={classes}>{children}</div>
}
